module.exports = __webpack_public_path__ + "KaTeX_Fraktur-Regular.12fe5ce1.woff2";